var React = require('react');

function Ok (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8 8.262c1.999 0 3.584-1.606 3.584-3.631C11.584 2.676 9.999 1 8 1S4.416 2.606 4.416 4.63c0 2.026 1.585 3.632 3.584 3.632zm0-5.097c.827 0 1.516.698 1.516 1.466 0 .838-.689 1.466-1.516 1.466-.827 0-1.516-.698-1.516-1.466S7.173 3.165 8 3.165zm1.447 8.03l2.137 2.024a1.022 1.022 0 010 1.467 1.072 1.072 0 01-1.516 0l-2-1.955-1.998 1.955c-.207.21-.482.28-.758.28s-.551-.07-.758-.28a1.022 1.022 0 010-1.467l1.999-2.024c-.69-.14-1.448-.42-2.068-.838-.482-.35-.62-.978-.344-1.467.275-.489.964-.628 1.447-.349 1.447.908 3.377.908 4.824 0 .483-.28 1.172-.14 1.447.35.276.488.138 1.186-.344 1.466-.62.419-1.31.698-2.068.838z"}));
}

Ok.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Ok;

Ok.default = Ok;
